{
  "version": 1,
  "asset_id": "afc2c8d9-fbef-4c82-bf1e-a018420ce84a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/afc2c8d9-fbef-4c82-bf1e-a018420ce84a/svc-aeo-geo-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/afc2c8d9-fbef-4c82-bf1e-a018420ce84a/svc-aeo-geo-640.webp",
  "original_filename": "svc-aeo-geo-640.webp",
  "size": 3314,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:38Z"
}
